import { orderBy } from 'lodash';

export const returnCombinedInAndOutData = (inData, outData) => {
  if (inData && outData) {
    const combinedData = [
      ...inData
        .map((item) => returnFormattedAdditionalInfoData(item, 'IN'))
        .filter((item) => item !== null),
      ...outData
        .map((item) => returnFormattedAdditionalInfoData(item, 'OUT'))
        .filter((item) => item !== null)
    ];

    return combinedData;
  }

  return null;
};

export const returnAdditionalInfoColumnsAndItems = (data, settings) => {
  if (data && settings) {
    const orderedSettings = orderBy(settings, ['columnIndex'], ['asc']);
    return orderedSettings
      .map((currentColumn) => {
        if (currentColumn) {
          if (currentColumn.columnVisibility) {
            const { columnDetail, columnName } = currentColumn;
            if (Array.isArray(columnDetail)) {
              const orderedItems = orderBy(
                columnDetail,
                ['itemIndex'],
                ['asc']
              );
              const columnItems = orderedItems
                .map((currentItem) => {
                  if (currentItem.visibility) {
                    const itemName = currentItem.itemName;
                    if (itemName) {
                      const selectedData = data.filter(
                        (item) => item.transactionName === itemName
                      );
                      if (selectedData[0]) {
                        const currentData = selectedData[0];
                        return {
                          ...currentData,
                          transactionName: currentItem.itemLabel
                        };
                      }
                    }
                  }

                  return null;
                })
                .filter((item) => item !== null);
              return {
                columnName,
                items: columnItems
              };
            }
          }
        }

        return null;
      })
      .filter((item) => item !== null);
  }

  return null;
};

const returnFormattedAdditionalInfoData = (data, transactionDirection) => {
  if (data) {
    switch (String(data.transactionName).toUpperCase()) {
      case 'AVERAGE - CASH':
        return {
          ...data,
          transactionName: `averageCash${
            transactionDirection === 'IN' ? 'In' : 'Out'
          }`
        };

      case 'MAX - CASH':
        return {
          ...data,
          transactionName: `maxCash${
            transactionDirection === 'IN' ? 'In' : 'Out'
          }`
        };

      case 'AVERAGE - NON CASH':
        return {
          ...data,
          transactionName: `averageNonCash${
            transactionDirection === 'IN' ? 'In' : 'Out'
          }`
        };

      case 'MAX - NON CASH':
        return {
          ...data,
          transactionName: `maxNonCash${
            transactionDirection === 'IN' ? 'In' : 'Out'
          }`
        };

      case 'AVERAGE - REMITTANCE':
        return {
          ...data,
          transactionName: `averageRemittance${
            transactionDirection === 'IN' ? 'In' : 'Out'
          }`
        };

      case 'MAX - REMITTANCE':
        return {
          ...data,
          transactionName: `maxRemittance${
            transactionDirection === 'IN' ? 'In' : 'Out'
          }`
        };

      default:
        return null;
    }
  }

  return null;
};
